import { createFileRoute } from '@tanstack/react-router'
import { ShareAchievementPage } from '@/components/SharablePage/ShareAchievementPage'

export const Route = createFileRoute('/my-shares/$challengeSlug')({
  component: () => <ShareAchievementPage />,
})
